module.exports = __webpack_public_path__ + "img/norcott_b4.b169043c.jpg";